/* shto-scp-pdp-scoop: "See the full ingredient list" (when its Link setting is empty) scrolls to the buy box's accordion
   whose title matches the "Accordion to open" setting and opens it. Only scrolls: nothing is written into the address.
   No such accordion on the page: it scrolls to the buy box; no buy box: nothing happens. */
(function () {
  if (window.ShtoScpPdpScoop) return;
  window.ShtoScpPdpScoop = true;

  function clean(t) { return (t || '').replace(/\s+/g, ' ').trim().toLowerCase(); }

  // Bottom edge of the store's sticky header (and anything else pinned to the top), so the target isn't hidden under it.
  function topCover() {
    var bottom = 0;
    document.querySelectorAll('.shopify-section-group-header-group, header, [class*="header-sticky"]').forEach(function (el) {
      var cs = getComputedStyle(el);
      if (cs.position !== 'sticky' && cs.position !== 'fixed') return;
      var r = el.getBoundingClientRect();
      if (r.top <= 1 && r.bottom > bottom && r.bottom < window.innerHeight / 2) bottom = r.bottom;
    });
    return bottom;
  }

  function findTarget(title) {
    var buy = document.querySelector('[data-shto-section="shto-scp-pdp-buy"]');
    if (!buy) return null;
    var want = clean(title), list = buy.querySelectorAll('details'), i, s;
    if (want) {
      for (i = 0; i < list.length; i++) { s = list[i].querySelector('summary'); if (s && clean(s.textContent) === want) return list[i]; }
      for (i = 0; i < list.length; i++) { s = list[i].querySelector('summary'); if (s && clean(s.textContent).indexOf(want) === 0) return list[i]; }
    }
    return buy;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.shto-scp-pdp-scoop-link[data-shto-open-accordion]');
    if (!btn) return;
    var target = findTarget(btn.getAttribute('data-shto-open-accordion'));
    if (!target) return;
    e.preventDefault();
    var isDetails = target.tagName === 'DETAILS';
    if (isDetails && !target.open) {
      // Let the buy box's own toggle handling run (it may animate or close the others).
      var summary = target.querySelector('summary');
      if (summary) summary.click();
      if (!target.open) target.open = true;
    }
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var y = target.getBoundingClientRect().top + window.pageYOffset - topCover() - 16;
    window.scrollTo({ top: Math.max(0, y), behavior: reduce ? 'auto' : 'smooth' });
    var focusEl = isDetails ? target.querySelector('summary') : target;
    if (focusEl) {
      if (!isDetails && !focusEl.hasAttribute('tabindex')) focusEl.setAttribute('tabindex', '-1');
      try { focusEl.focus({ preventScroll: true }); } catch (err) {}
    }
  });
})();
